import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import ProductSearch from './components/ProductSearch';
import ProductDetail from './components/ProductDetail';
import BrandPage from './components/BrandPage';
import IngredientList from './components/IngredientList';
import IngredientDetail from './components/IngredientDetail';
import CheckerLandingPage from './components/CheckerLandingPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<ProductSearch />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/brands/:slug" element={<BrandPage />} />
        <Route path="/ingredients" element={<IngredientList />} />
        <Route path="/ingredients/:slug" element={<IngredientDetail />} />
        <Route path="/acne-safe-ingredient-checker" element={<CheckerLandingPage pageKey="acne-safe-ingredient-checker" />} />
        <Route path="/pore-clogging-ingredient-checker" element={<CheckerLandingPage pageKey="pore-clogging-ingredient-checker" />} />
        <Route path="/comedogenic-ingredient-checker" element={<CheckerLandingPage pageKey="comedogenic-ingredient-checker" />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </Router>
  );
}

export default App;
